"use client";

import { useEffect } from "react";

/** Root `<html lang>` is static; sync the active locale for a11y / SEO. */
export default function DocumentLang({ locale }: { locale: string }) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);
  return null;
}
